module.exports = __webpack_public_path__ + "img/energy_icon1.ef776471.png";